const AmenitiesTableParser = {};

AmenitiesTableParser.getAmenitiesTableParser = (res) => {
  if (res) {
    res = res.result.reverse();
  }

  if (!res) {
    return {};
  }
};

AmenitiesTableParser.postAmenitiesParser = (res) => {

  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }
};

export { AmenitiesTableParser };
